module.exports = __webpack_public_path__ + "static/media/pastorinagbaja.cb6580b5.jpg";